import React, { useState, useEffect } from 'react'
import api from '../services/api'

// 将纯文本转换为HTML段落格式
const textToHtml = (text) => {
  if (!text) return ''
  
  // 如果内容已经包含HTML标签，直接返回
  if (/<[a-z][\s\S]*>/i.test(text)) {
    return text
  }
  
  // 将纯文本按换行符分割，转换为<p>标签
  const paragraphs = text.split('\n').filter(p => p.trim())
  return paragraphs.map(p => `<p>${p.trim()}</p>`).join('')
}

const VideosSection = () => {
  const [siteInfo, setSiteInfo] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await api.get('/site-info')
      if (res.code === 0) {
        setSiteInfo(res.data)
      } else {
        setError('加载数据失败')
      }
    } catch (err) {
      setError('加载数据失败')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <section className="section">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>加载中...</p>
        </div>
      </section>
    )
  }

  if (error || !siteInfo) {
    return (
      <section className="section">
        <div className="error">{error || '暂无数据'}</div>
      </section>
    )
  }

  return (
    <section className="section" style={{ maxWidth: 900, margin: '0 auto' }}>
      <div className="section-header">
        <span className="section-title">联系站长</span>
        <span className="section-count">// 与站长互动</span>
      </div>
      
      {/* 关于站长 */}
      <div className="contact-section">
        <h3 className="contact-section-title">{siteInfo.about_title || '👋 关于站长 & 联系我'}</h3>
        <div 
          className="contact-section-content" 
          dangerouslySetInnerHTML={{ __html: textToHtml(siteInfo.about_content) }}
        />
      </div>

      {/* 联系方式 */}
      <div className="contact-section">
        <h3 className="contact-section-title">{siteInfo.contact_title || '📮 联系方式'}</h3>
        <div 
          className="contact-section-content contact-section-content-no-indent" 
          dangerouslySetInnerHTML={{ __html: textToHtml(siteInfo.contact_content) }}
        />
      </div>

      {/* 支持本站 */}
      <div className="contact-section">
        <h3 className="contact-section-title">{siteInfo.support_title || '💖 支持本站'}</h3>
        <div 
          className="contact-section-content" 
          dangerouslySetInnerHTML={{ __html: textToHtml(siteInfo.support_content) }}
        />
        
        {/* 二维码 */}
        {(siteInfo.wechat_qr || siteInfo.reward_qr) && (
          <div className="qr-code-container">
            {siteInfo.wechat_qr && (
              <div className="qr-code-item">
                <img src={siteInfo.wechat_qr} alt="微信公众号二维码" />
                <p>微信公众号</p>
              </div>
            )}
            {siteInfo.reward_qr && (
              <div className="qr-code-item">
                <img src={siteInfo.reward_qr} alt="打赏收款二维码" />
                <p>打赏支持</p>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  )
}

export default VideosSection
